import { Slot } from "radix-ui";
import type * as React from "react";
import { cn } from "@/lib/utils";

/** Primer's BorderBox: a flat bordered box with an optional gray header and body sections divided by rules. */
function Card({ className, asChild = false, ...props }: React.ComponentProps<"div"> & { asChild?: boolean }) {
  const Comp = asChild ? Slot.Root : "div";
  return <Comp data-slot="card" className={cn("mt-4 min-w-0 overflow-hidden rounded-md border bg-card text-card-foreground", className)} {...props} />;
}

function CardHeader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-header"
      className={cn("flex min-h-12 items-center gap-2 border-b bg-muted px-4 py-2 font-semibold [&_.text-muted-foreground]:font-normal", className)}
      {...props}
    />
  );
}

function CardContent({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="card-content" className={cn("p-4 [[data-slot=card-content]+&]:border-t [[data-slot=card-content]+&]:border-border-muted", className)} {...props} />;
}

export { Card, CardContent, CardHeader };
